// No op tracer to avoid importing the lib in client side JS
// eslint-disable-next-line import/no-mutable-exports
let tracer = {
    trace: (name, options, callback = options) => {
        return callback();
    },
    wrap: (name, options, fn = options) => {
        return fn;
    },
    startSpan: () => ({
        finish: () => {},
    }),
};

// Stolen from https://github.com/iliakan/detect-node
const isNode =
    Object.prototype.toString.call(
        typeof process !== 'undefined' ? process : 0,
    ) === '[object process]';

if (isNode) {
    // eslint-disable-next-line global-require
    tracer = require('../../server/src/tracer').default;
}

export default tracer;
